module.exports = __webpack_public_path__ + "img/ewms.a6400f5c.png";